import { Directive, Input, HostListener, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[ccDebounceValueChange]'
})
export class DebounceValueChangeDirective implements OnDestroy {
  @Output() public ccDebounceValueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() public valueChangeDelay = 500;

  private stream: Subject<any> = new Subject<any>();
  private subscription: Subscription;

  constructor() {
    this.subscription = this.stream
      .pipe(debounceTime(this.valueChangeDelay))
      .subscribe((value: any) => this.ccDebounceValueChange.next(value));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('input', ['$event'])
  public onValueChange(value: any): void {
    this.stream.next(value);
  }
}
